import styled from "styled-components";

export const DRFWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 3rem 1.3rem;

  .invite-button {
    justify-items: end;
    width: 100%;
    margin-bottom: 1rem;
  }
  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
  }

  @media (min-width: ${({ theme }) => theme.screen.tablet}) {
  }

  @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
  }
`;

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  align-items: center;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 5rem;
`;
